import React from 'react';
import { UserCog, MapPin, ShieldCheck, Check, Minus } from 'lucide-react';
import { FLEET_PERMISSION, PERMISSION_GROUPS, can } from '../../utils/fleetPermissions';
import './SupervisorAccountPage.css';

/**
 * Bölge sorumlusunun KENDİ hesap ekranı.
 *
 * Sorumlu, filo profilini (vergi numarası, firma iletişim bilgileri, logo yönetimi,
 * hesap silme) GÖRMEZ — bunlar filo sahibinin verisidir ve sorumlu bunları
 * yönetemez. Bu ekran yalnız sorumluya ait olanı gösterir: kim olduğu, hangi
 * bölgelerden sorumlu olduğu ve hangi yetkileri taşıdığı.
 *
 * Yetkiler salt okunurdur; değiştirme yalnız filo sahibindedir (Bölge Sorumluları ekranı).
 */
const SupervisorAccountPage = ({ ctx }) => {
    const areas = ctx?.areas || [];

    return (
        <div className="sa-page">
            <div className="sa-card">
                <div className="sa-head">
                    <div className="sa-avatar"><UserCog size={22} /></div>
                    <div>
                        <h2 className="sa-name">{ctx?.displayName || 'Bölge Sorumlusu'}</h2>
                        <p className="sa-sub">Bölge Sorumlusu, {ctx?.fleetName || 'Filo'}</p>
                    </div>
                </div>
                <p className="sa-note">
                    Bu hesap, filo yöneticisinin size tanımladığı bölgelerdeki operasyonu yönetir.
                    Bölge ve yetki değişikliği için filo yöneticinizle görüşün.
                </p>
            </div>

            <div className="sa-card">
                <div className="sa-section-head">
                    <MapPin size={16} />
                    <h3>Sorumlu Olduğunuz Bölgeler</h3>
                    <span className="sa-badge">{areas.length}</span>
                </div>
                {areas.length === 0 ? (
                    <p className="sa-empty">Tanımlı bölge yok. Filo yöneticinizle görüşün.</p>
                ) : (
                    <div className="sa-chips">
                        {areas.map((a, i) => (
                            <span key={`${a.districtId || ''}${a.regionId || ''}${a.subRegionId || ''}${i}`} className="sa-chip">
                                {a.displayName}
                            </span>
                        ))}
                    </div>
                )}
            </div>

            <div className="sa-card">
                <div className="sa-section-head">
                    <ShieldCheck size={16} />
                    <h3>Yetkileriniz</h3>
                </div>
                <div className="sa-perm-grid">
                    {PERMISSION_GROUPS.map((group) => (
                        <div key={group.label} className="sa-perm-group">
                            <h4>{group.label}</h4>
                            {group.keys.map(([key, label]) => {
                                const granted = can(ctx, FLEET_PERMISSION[key]);
                                return (
                                    <div key={key} className={`sa-perm-row ${granted ? 'is-on' : ''}`}>
                                        {granted ? <Check size={14} /> : <Minus size={14} />}
                                        <span>{label}</span>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SupervisorAccountPage;
